/* ══════════════════════════════════════════
   VIVISHA SHOPIFY THEME — JS
   ══════════════════════════════════════════ */

const Vivisha = (() => {

  /* ── TOAST ── */
  const toast = {
    _timer: null,
    show(msg, duration = 3000) {
      const el = document.getElementById('toast');
      const msgEl = document.getElementById('toast-msg');
      if (!el || !msgEl) return;
      msgEl.textContent = msg;
      el.classList.add('toast--visible');
      clearTimeout(this._timer);
      this._timer = setTimeout(() => el.classList.remove('toast--visible'), duration);
    }
  };

  /* ── CART ── */
  const cart = {
    open() {
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close() {
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    async addItem(variantId, quantity = 1) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await cart.refresh();
        cart.open();
        toast.show('✦ Added to your bag');
      } catch (e) {
        toast.show('Could not add item. Please try again.');
        console.error(e);
      }
    },
    async updateItem(key, quantity) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        if (!res.ok) throw new Error('Update failed');
        const data = await res.json();
        cart.updateUI(data);
      } catch (e) {
        console.error(e);
      }
    },
    async refresh() {
      try {
        const res = await fetch('/cart.js');
        const data = await res.json();
        cart.updateUI(data);
      } catch (e) {
        console.error(e);
      }
    },
    updateUI(data) {
      window.cartData = data;
      /* count badges */
      const count = data.item_count;
      ['header-cart-count', 'cart-drawer-count'].forEach(id => {
        const el = document.getElementById(id);
        if (!el) return;
        if (id === 'header-cart-count') {
          el.textContent = count;
          el.classList.toggle('hidden', count === 0);
        } else {
          el.textContent = `(${count})`;
        }
      });
      /* subtotal */
      const subtotalEl = document.getElementById('cart-subtotal-price');
      if (subtotalEl) subtotalEl.textContent = Vivisha.money(data.total_price);
      /* ── FREE SHIPPING TRACKER ── */
      const FREE_THRESHOLD = 99900; // ₹999 in paise
      const trackerMsg = document.getElementById('tracker-msg');
      const trackerFill = document.getElementById('tracker-fill');
      if (trackerMsg && trackerFill) {
        const subtotal = data.total_price;
        const pct = Math.min((subtotal / FREE_THRESHOLD) * 100, 100);
        trackerFill.style.width = pct + '%';
        if (subtotal >= FREE_THRESHOLD) {
          trackerMsg.innerHTML = '🚚 You have unlocked <strong>Free Shipping</strong>!';
          trackerMsg.classList.add('tracker-msg--success');
        } else {
          const remaining = Vivisha.money(FREE_THRESHOLD - subtotal);
          trackerMsg.innerHTML = `Add <strong>${remaining}</strong> more to unlock ✦ <strong>Free Shipping</strong>`;
          trackerMsg.classList.remove('tracker-msg--success');
        }
      }
      /* drawer body */
      const bodyEl = document.getElementById('cart-drawer-body');
      const footerEl = document.getElementById('cart-footer');
      if (!bodyEl) return;
      if (count === 0) {
        bodyEl.innerHTML = `
          <div class="cart-empty">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" width="52" height="52"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"/></svg>
            <p>Your bag is empty</p>
            <a href="/collections/all" class="btn btn--primary">Start Shopping</a>
          </div>`;
        if (footerEl) footerEl.style.display = 'none';
        return;
      }
      if (footerEl) {
        footerEl.style.display = '';
        /* Ensure checkout button exists in footer (it may be missing if cart was empty on page load) */
        if (!footerEl.querySelector('#cart-checkout-btn')) {
          footerEl.innerHTML = `
            <div class="cart-subtotal">
              <span class="cart-subtotal__label">Subtotal</span>
              <span class="cart-subtotal__price" id="cart-subtotal-price">${Vivisha.money(data.total_price)}</span>
            </div>
            <p class="cart-note">Shipping &amp; taxes calculated at checkout</p>
            <form action="/cart" method="post" id="cart-drawer-form">
              <button type="submit" name="checkout" id="cart-checkout-btn" class="btn btn--primary btn--full">Proceed to Checkout</button>
            </form>
            <a href="/cart" class="btn btn--outline btn--full" onclick="Vivisha.cart.close()">View Full Cart</a>`;
        }
      }
      let html = '<div class="cart-items" id="cart-items-list">';
      data.items.forEach(item => {
        html += `
          <div class="cart-item" data-cart-key="${item.key}">
            <div class="cart-item__image">
              ${item.image
                ? `<img src="${item.image}" alt="${item.title}" loading="lazy" width="72">`
                : `<div class="cart-item__placeholder">${item.title.charAt(0)}</div>`}
            </div>
            <div class="cart-item__details">
              <a class="cart-item__name" href="${item.url}">${item.product_title}</a>
              ${item.variant_title && item.variant_title !== 'Default Title'
                ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
              <p class="cart-item__price">${Vivisha.money(item.final_price)}</p>
              <div class="cart-item__qty-row">
                <div class="qty-control">
                  <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
                  <span class="qty-num">${item.quantity}</span>
                  <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
                </div>
                <button class="cart-item__remove" data-key="${item.key}" data-qty="0" aria-label="Remove item">Remove</button>
              </div>
            </div>
          </div>`;
      });
      html += '</div>';
      bodyEl.innerHTML = html;
      cart._bindQtyBtns();
      
      /* recalculate max quantities on product forms based on new cart */
      document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
        const variantsScript = form.querySelector('[data-product-variants]');
        if (!variantsScript) return;
        const variantsList = JSON.parse(variantsScript.textContent);
        const input = form.querySelector('input[name="id"]');
        if (input && input.value && typeof Vivisha !== 'undefined' && Vivisha.variants) {
          const activeVariant = variantsList.find(v => v.id.toString() === input.value.toString());
          if (activeVariant) {
            Vivisha.variants.updateQuantityStock(form, activeVariant);
          }
        }
      });
    },
    _bindQtyBtns() {
      document.querySelectorAll('.qty-btn, .cart-item__remove').forEach(btn => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.key;
          const qty = parseInt(btn.dataset.qty, 10);
          if (key) cart.updateItem(key, qty);
        });
      });
    },
    init() {
      /* delegated qty button handler for Liquid-rendered cart */
      document.addEventListener('click', e => {
        const btn = e.target.closest('.qty-btn, .cart-item__remove');
        if (!btn) return;
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty, 10);
        if (key !== undefined && !isNaN(qty)) cart.updateItem(key, qty);
      });
      /* product form intercept */
      document.addEventListener('submit', async e => {
        const form = e.target.closest('[data-type="add-to-cart-form"]');
        if (!form) return;
        e.preventDefault();
        const btn = document.getElementById('add-to-cart-btn');
        const btnText = document.getElementById('add-to-cart-text');
        if (btn) btn.disabled = true;
        if (btnText) btnText.textContent = 'Adding…';
        const variantId = document.getElementById('product-variant-id')?.value;
        const quantity = parseInt(document.getElementById('quantity-input')?.value || '1', 10);
        if (variantId) await cart.addItem(parseInt(variantId, 10), quantity);
        if (btn) btn.disabled = false;
        if (btnText) btnText.textContent = 'Add to Cart';
      });
    }
  };

  /* ── SEARCH ── */
  const search = {
    open() {
      const drawer = document.getElementById('search-drawer');
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => document.getElementById('search-input')?.focus(), 300);
    },
    close() {
      const drawer = document.getElementById('search-drawer');
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  /* ── NAV ── */
  const nav = {
    open() {
      const el = document.getElementById('mobile-nav');
      if (!el) return;
      el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close() {
      const el = document.getElementById('mobile-nav');
      if (!el) return;
      el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  /* ── GALLERY ── */
  const gallery = {
    select(thumb, index) {
      document.querySelectorAll('.main-image-slide').forEach(img => img.classList.remove('active'));
      const activeImg = document.getElementById(`pd-main-img-${index}`);
      if (activeImg) activeImg.classList.add('active');

      document.querySelectorAll('.pd-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    },
    zoom() {
      const mainImg = document.querySelector('.main-image-slide.active');
      if (!mainImg) return;
      const overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.92);z-index:9999;display:flex;align-items:center;justify-content:center;cursor:zoom-out;';
      const img = document.createElement('img');
      img.src = mainImg.src || mainImg.getAttribute('src');
      img.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;';
      overlay.appendChild(img);
      overlay.addEventListener('click', () => document.body.removeChild(overlay));
      document.body.appendChild(overlay);
    },
    filterByColour(colourValue) {
      const slug = (colourValue || '').toLowerCase().trim();

      const gallery = document.getElementById('pd-gallery');
      if (!gallery) return;

      const allSlides = Array.from(gallery.querySelectorAll('.main-image-slide'));
      const allThumbs = Array.from(gallery.querySelectorAll('.pd-thumb'));

      /* Build the visible set from thumb button data-colour-group attributes.
         Thumb buttons are plain HTML elements and reliably carry data-* attrs.
         image_tag silently strips unknown attributes so we cannot rely on the <img> itself. */
      const matchingThumbs = allThumbs.filter(t =>
        (t.dataset.colourGroup || '').toLowerCase().trim() === slug
      );

      /* Fall back to ALL images when this colour has no tagged thumbnails */
      const targetThumbs = matchingThumbs.length > 0 ? matchingThumbs : allThumbs;

      /* Build a sorted set of slide indices from the matching thumbs */
      const visibleIndices = new Set(
        targetThumbs
          .map(t => parseInt(t.dataset.index, 10))
          .filter(n => !isNaN(n))
      );

      /* Remove active from every slide and thumb before reassigning */
      allSlides.forEach(s => s.classList.remove('active'));
      allThumbs.forEach(t => t.classList.remove('active'));

      /* Show/hide main slides by their position in the NodeList */
      allSlides.forEach((slide, i) => {
        slide.style.display = visibleIndices.has(i) ? '' : 'none';
      });

      /* Show/hide thumbnails by their data-index */
      allThumbs.forEach(thumb => {
        const idx = parseInt(thumb.dataset.index, 10);
        thumb.style.display = visibleIndices.has(idx) ? '' : 'none';
      });

      /* Activate the lowest-index visible slide and its matching thumb */
      const firstIdx = [...visibleIndices].sort((a, b) => a - b)[0];
      if (firstIdx !== undefined) {
        const firstSlide = document.getElementById(`pd-main-img-${firstIdx}`);
        if (firstSlide) firstSlide.classList.add('active');

        const firstThumb = allThumbs.find(t => parseInt(t.dataset.index, 10) === firstIdx);
        if (firstThumb) firstThumb.classList.add('active');
      }
    }
  };

  /* ── VARIANTS ── */
  const variants = {
    selectOption(btn) {
      const position = parseInt(btn.dataset.optionPosition, 10);
      const value = btn.dataset.value;
      const form = btn.closest('form');
      if (!form) return;

      /* update label */
      const optionContainer = btn.closest('.pd-option');
      if (optionContainer) {
        const label = optionContainer.querySelector('[data-option-selected]');
        if (label) label.textContent = value;
      }
      
      /* toggle active */
      const siblings = optionContainer ? optionContainer.querySelectorAll('button[data-value]') : [];
      siblings.forEach(s => s.classList.remove('active'));
      btn.classList.add('active');

      /* if this is a colour option, filter the gallery */
      if (btn.closest('.pd-colors')) {
        gallery.filterByColour(value);
      }

      /* get variants */
      const variantsScript = form.querySelector('[data-product-variants]');
      const variantsList = variantsScript ? JSON.parse(variantsScript.textContent) : window.productVariants;
      if (!variantsList) return;

      /* find matching variant */
      const selected = {};
      form.querySelectorAll('[data-option-position].active').forEach(el => {
        selected[el.dataset.optionPosition] = el.dataset.value;
      });

      const variant = variantsList.find(v =>
        v.options.every((opt, i) => !selected[i + 1] || selected[i + 1] === opt)
      );
      if (!variant) return;

      /* update hidden input */
      const input = form.querySelector('input[name="id"]') || document.getElementById('product-variant-id');
      if (input) input.value = variant.id;

      /* update URL if this form belongs to the main product page */
      if (form.closest('.section-main-product')) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({ path: url.href }, '', url.href);
      }
      /* update price */
      const priceEl = form.querySelector('.pd-price-block') || document.getElementById('pd-price-block');
      if (priceEl && variant.price) {
        let html = `
          <div class="pd-price-main">
            <span class="pd-price">${Vivisha.money(variant.price)}</span>`;
        if (variant.compare_at_price > variant.price) {
          const discount = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          const savings = variant.compare_at_price - variant.price;
          html += `
            <span class="pd-price-old">MRP: ${Vivisha.money(variant.compare_at_price)}</span>
            <span class="pd-discount-badge">${discount}% OFF</span>
          </div>
          <p class="pd-savings">You Save: ${Vivisha.money(savings)}</p>`;
        } else {
          html += `</div>`;
        }
        priceEl.innerHTML = html;
      }
      /* update quantity limit and stock indicator */
      this.updateQuantityStock(form, variant);
    },
    updateQuantityStock(form, variant) {
      if (!variant) return;
      const qtyInput = form.querySelector('.qty-input');
      const indicator = form.querySelector('[data-stock-indicator]');

      let inCart = 0;
      if (window.cartData && window.cartData.items) {
        const item = window.cartData.items.find(i => i.variant_id === variant.id || i.id === variant.id);
        if (item) inCart = item.quantity;
      }

      let maxAvailable = null;
      let displayMessage = '';

      if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
        maxAvailable = Math.max(0, variant.inventory_quantity - inCart);
        
        if (qtyInput) {
          qtyInput.max = maxAvailable;
          if (parseInt(qtyInput.value, 10) > maxAvailable) {
            qtyInput.value = Math.max(1, maxAvailable);
          }
        }
        
        if (maxAvailable === 0) {
           displayMessage = inCart > 0 ? `All ${inCart} available in your cart` : 'Out of stock';
        } else if (maxAvailable === 1) {
           displayMessage = 'Only 1 left';
        } else if (maxAvailable <= 5) {
           displayMessage = `Only ${maxAvailable} left`;
        }
      } else {
        if (qtyInput) qtyInput.removeAttribute('max');
      }

      if (indicator) {
        indicator.textContent = displayMessage;
      }

      /* update add to cart button availability */
      const atcBtn = form.querySelector('.pd-add-cart') || document.getElementById('add-to-cart-btn');
      const atcText = atcBtn ? atcBtn.querySelector('span') : document.getElementById('add-to-cart-text');
      
      if (atcBtn) {
        const isAvailable = variant.available && (maxAvailable === null || maxAvailable > 0);
        atcBtn.disabled = !isAvailable;
        
        let btnText = 'Add to Cart';
        if (!variant.available) {
          btnText = 'Sold Out';
        } else if (maxAvailable === 0) {
          btnText = 'Limit Reached';
        }

        if (atcText) {
          atcText.textContent = btnText;
        } else {
          atcBtn.textContent = btnText;
        }

        if (!isAvailable) {
          atcBtn.classList.add('pd-add-cart--disabled');
        } else {
          atcBtn.classList.remove('pd-add-cart--disabled');
        }
      }
    }
  };

  /* ── WISHLIST ── */
  const wishlist = {
    _key: 'vivisha_wishlist',
    get() {
      try { return JSON.parse(localStorage.getItem(this._key) || '[]'); } catch { return []; }
    },
    save(list) {
      try { localStorage.setItem(this._key, JSON.stringify(list)); } catch {}
    },
    toggle(productId, btn) {
      let list = this.get();
      const id = parseInt(productId, 10);
      const idx = list.indexOf(id);
      if (idx === -1) {
        list.push(id);
        btn?.classList.add('active');
        toast.show('✦ Added to Wishlist');
      } else {
        list.splice(idx, 1);
        btn?.classList.remove('active');
        toast.show('Removed from Wishlist');
      }
      this.save(list);
      this.syncAll();
    },
    syncAll() {
      const list = this.get();
      document.querySelectorAll('[data-product-id]').forEach(el => {
        const id = parseInt(el.dataset.productId, 10);
        const btn = el.querySelector('.wishlist-toggle') || (el.id === `wishlist-btn` ? el : null);
        if (btn) btn.classList.toggle('active', list.includes(id));
      });
      const mainBtn = document.getElementById('wishlist-btn');
      if (mainBtn) {
        const pid = parseInt(mainBtn.closest('[id^="product-"]')?.id?.replace('product-', ''), 10);
        if (!isNaN(pid)) mainBtn.classList.toggle('active', list.includes(pid));
      }
    },
    init() { this.syncAll(); }
  };

  /* ── TABS / FILTER ── */
  const tabs = {
    filter(btn) {
      const filter = btn.dataset.filter;
      document.querySelectorAll('.collection-tab').forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      document.querySelectorAll('.product-card').forEach(card => {
        if (filter === 'all') {
          card.style.display = '';
        } else {
          const tags = card.dataset.tags || '';
          card.style.display = tags.includes(filter) ? '' : 'none';
        }
      });
    }
  };

  /* ── KEYBOARD ACCESSIBILITY ── */
  const a11y = {
    init() {
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          cart.close();
          search.close();
          nav.close();
          filter.close();
        }
      });
    }
  };

  /* ── LOOKBOOK HOTSPOTS ── */
  const lookbook = {
    toggle(dotBtn) {
      const hotspot = dotBtn.closest('.hotspot');
      if (!hotspot) return;
      const isOpen = hotspot.classList.contains('active');
      // Close all others
      document.querySelectorAll('.hotspot.active').forEach(h => {
        h.classList.remove('active');
        h.querySelector('.hotspot__dot')?.setAttribute('aria-expanded', 'false');
        h.querySelector('.hotspot__card')?.setAttribute('aria-hidden', 'true');
      });
      if (!isOpen) {
        hotspot.classList.add('active');
        dotBtn.setAttribute('aria-expanded', 'true');
        hotspot.querySelector('.hotspot__card')?.setAttribute('aria-hidden', 'false');
      }
    },
    close(closeBtn) {
      const hotspot = closeBtn.closest('.hotspot');
      if (!hotspot) return;
      hotspot.classList.remove('active');
      hotspot.querySelector('.hotspot__dot')?.setAttribute('aria-expanded', 'false');
      hotspot.querySelector('.hotspot__card')?.setAttribute('aria-hidden', 'true');
    }
  };

  /* ── FILTER DRAWER & SIDEBAR (Mirraw/Impact-Style) ── */
  const filter = {
    open() {
      const drawer = document.getElementById('filter-drawer');
      const overlay = document.getElementById('filter-overlay');
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      overlay?.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close() {
      const drawer = document.getElementById('filter-drawer');
      const overlay = document.getElementById('filter-overlay');
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      overlay?.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    switchTab(btn, index) {
      document.querySelectorAll('.filter-cat-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      document.querySelectorAll('.filter-opts__group').forEach(g => g.classList.remove('active'));
      const group = document.getElementById(`filter-group-${index}`);
      if (group) group.classList.add('active');
    },
    toggleSidebar() {
      const body = document.getElementById('collection-body');
      const label = document.getElementById('filter-toggle-label');
      if (!body) return;
      
      const isHidden = body.classList.toggle('sidebar-hidden');
      localStorage.setItem('vivisha_sidebar_hidden', isHidden);
      
      if (label) {
        label.textContent = isHidden ? 'Show Filters' : 'Hide Filters';
      }
    },
    toggleAccordion(btn) {
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
      
      const icon = btn.querySelector('.sidebar-filter-icon');
      if (icon) {
        icon.textContent = !isExpanded ? '−' : '+';
      }
    },
    updateVisuals(wrap) {
      const minInput = wrap.querySelector('.price-slider-input--min');
      const maxInput = wrap.querySelector('.price-slider-input--max');
      const rangeBar = wrap.querySelector('.price-slider-range');
      const minValText = wrap.querySelector('.price-slider-min-val');
      const maxValText = wrap.querySelector('.price-slider-max-val');
      if (!minInput || !maxInput) return;
      
      const minVal = parseInt(minInput.value, 10);
      const maxVal = parseInt(maxInput.value, 10);
      const rangeMax = parseInt(minInput.max, 10);
      
      const percent1 = (minVal / rangeMax) * 100;
      const percent2 = (maxVal / rangeMax) * 100;
      
      if (rangeBar) {
        rangeBar.style.left = percent1 + '%';
        rangeBar.style.width = (percent2 - percent1) + '%';
      }
      
      if (minValText) minValText.textContent = minVal;
      if (maxValText) maxValText.textContent = maxVal;
    },
    applyPrice(wrap) {
      this.apply();
    },
    apply() {
      const form = document.createElement('form');
      form.method = 'get';
      form.action = window.location.pathname;
      
      // Sort by
      const sortEl = document.getElementById('sort-by');
      if (sortEl && sortEl.value) {
        const sortInput = document.createElement('input');
        sortInput.type = 'hidden';
        sortInput.name = 'sort_by';
        sortInput.value = sortEl.value;
        form.appendChild(sortInput);
      }
      
      // Checkboxes (from both sidebar and mobile drawer)
      document.querySelectorAll('#collection-sidebar input[type="checkbox"]:checked, .filter-drawer input[type="checkbox"]:checked').forEach(cb => {
        if (form.querySelector(`input[name="${cb.name}"][value="${cb.value}"]`)) return;
        const inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = cb.name;
        inp.value = cb.value;
        form.appendChild(inp);
      });
      
      // Price range
      let priceWrap = document.getElementById('price-slider-wrap-desktop');
      const drawer = document.getElementById('filter-drawer');
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        priceWrap = document.getElementById('price-slider-wrap-mobile');
      }
      
      if (priceWrap) {
        const minInput = priceWrap.querySelector('.price-slider-input--min');
        const maxInput = priceWrap.querySelector('.price-slider-input--max');
        const paramMin = priceWrap.dataset.paramMin;
        const paramMax = priceWrap.dataset.paramMax;
        
        if (minInput && maxInput) {
          const minVal = parseInt(minInput.value, 10);
          const maxVal = parseInt(maxInput.value, 10);
          const rangeMax = parseInt(minInput.max, 10);
          
          if (minVal > 0) {
            const inp = document.createElement('input');
            inp.type = 'hidden';
            inp.name = paramMin;
            inp.value = minVal;
            form.appendChild(inp);
          }
          if (maxVal < rangeMax) {
            const inp = document.createElement('input');
            inp.type = 'hidden';
            inp.name = paramMax;
            inp.value = maxVal;
            form.appendChild(inp);
          }
        }
      }
      
      document.body.appendChild(form);
      form.submit();
    },
    init() {
      const wraps = document.querySelectorAll('.price-slider-wrap');
      wraps.forEach(wrap => {
        const minInput = wrap.querySelector('.price-slider-input--min');
        const maxInput = wrap.querySelector('.price-slider-input--max');
        if (!minInput || !maxInput) return;
        
        const update = () => {
          let minVal = parseInt(minInput.value, 10);
          let maxVal = parseInt(maxInput.value, 10);
          const step = parseInt(minInput.step, 10) || 50;
          
          if (minVal > maxVal - step) {
            if (document.activeElement === minInput) {
              minInput.value = maxVal - step;
            } else {
              maxInput.value = minVal + step;
            }
          }
          filter.updateVisuals(wrap);
        };
        
        minInput.addEventListener('input', update);
        maxInput.addEventListener('input', update);
        
        filter.updateVisuals(wrap);
      });
      
      const sidebarHidden = localStorage.getItem('vivisha_sidebar_hidden') === 'true';
      if (sidebarHidden) {
        const body = document.getElementById('collection-body');
        const label = document.getElementById('filter-toggle-label');
        if (body) body.classList.add('sidebar-hidden');
        if (label) label.textContent = 'Show Filters';
      }
    }
  };

  /* ── STICKY HEADER SHADOW ── */
  const header = {
    init() {
      const el = document.getElementById('site-header');
      if (!el) return;
      const obs = new IntersectionObserver(
        ([entry]) => el.classList.toggle('site-header--scrolled', !entry.isIntersecting),
        { threshold: 0, rootMargin: '-1px 0px 0px 0px' }
      );
      const sentinel = document.createElement('div');
      sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
      document.body.prepend(sentinel);
      obs.observe(sentinel);
    }
  };

  /* ── MONEY FORMATTER ── */
  function money(cents) {
    const amount = (cents / 100).toFixed(2);
    return `₹${parseFloat(amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
  }

  /* ── SCROLL REVEAL ── */
  const scrollReveal = {
    init() {
      const els = document.querySelectorAll('.reveal-on-scroll');
      if (!els.length) return;
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      els.forEach(el => obs.observe(el));
    }
  };

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', () => {
    cart.init();
    cart.refresh();
    wishlist.init();
    a11y.init();
    header.init();
    scrollReveal.init();
    filter.init();

    /* Filter gallery for the initially selected colour on product pages */
    const activeColourBtn = document.querySelector('.pd-colors .color-swatch.active');
    if (activeColourBtn) {
      gallery.filterByColour(activeColourBtn.dataset.value);
    }
  });

  return { cart, search, nav, gallery, variants, wishlist, tabs, toast, money, lookbook, filter };

})();
